import React, { useState, useEffect } from 'react';
import { fetchWithAuth } from '../utils/apiHelper';

const GiftCardDeactivate = () => {
  const [publicCode, setPublicCode] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (message || error) {
      const timer = setTimeout(() => {
        setMessage('');
        setError('');
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [message, error]);

  const handleDeactivate = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setIsLoading(true);
    try {
      const payload = { state: 'cancelado' };
      // Se usa publicCode en la URL para identificar la gift card
      const response = await fetchWithAuth(`/giftcards/${publicCode}`, {
        method: 'PUT',
        body: JSON.stringify(payload),
      });
      if (response.giftCard) {
        setMessage('Gift card desactivada correctamente.');
        setPublicCode('');
      } else {
        setError(response.error || 'Ocurrió un error.');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white p-6 rounded shadow">
      <h2 className="text-xl font-bold text-center mb-4 text-pink-800">Desactivar Gift Card</h2>
      {message && <div className="mb-4 p-2 bg-green-100 text-green-800 rounded">{message}</div>}
      {error && <div className="mb-4 p-2 bg-red-100 text-red-800 rounded">{error}</div>}
      <form onSubmit={handleDeactivate} className="space-y-4">
        <div>
          <label className="block text-gray-700 text-lg font-medium" htmlFor="publicCode">
            Código Público de la Tarjeta
          </label>
          <input
            type="text"
            id="publicCode"
            value={publicCode}
            onChange={(e) => setPublicCode(e.target.value)}
            placeholder="Ej: AB12EF34"
            className="w-full border rounded px-4 py-2 focus:ring-2 focus:ring-pink-500 text-lg"
            required
          />
        </div>
        <button
          type="submit"
          disabled={isLoading}
          className="w-full bg-pink-600 hover:bg-pink-700 text-white font-bold py-2 rounded transition text-lg"
        >
          {isLoading ? 'Desactivando...' : 'Desactivar'}
        </button>
      </form>
    </div>
  );
};

export default GiftCardDeactivate;
